<template>
    <div class="sy">
        <div class="nav_wrap">
            <nav class="w1200">
                <ul>
                    <li v-for="(item, i) in navData" :class="{ nav_li : active === i && i != 0, logo: i === 0 }" :key="i" @click="$router.push({ path: item.path, query: {page: i} }), active = i">
                        <img :src="item.name" alt="" v-if="i === 0">
                       <span v-else>{{item.name}}</span>
                    </li>
                    <!-- <li @click="changeLang(), zyqh? zyqh = false: zyqh = true">
                        <span class="rr" :class="{ zyw: zyqh }">中文</span>
                        <span :class="{ zyw : !zyqh }"> | ENGLISH</span>
                    </li> -->
                </ul>
            </nav>
        </div>
        <div class="container">
            <router-view></router-view>
        </div>
        <footers></footers>
    </div>
</template>

<script>
import Footers from '../components/Footer.vue'

export default {
  name: 'home',
  components: {
    Footers
  },
  data () {
    return {
      zyqh: true,
      active: this.$route.query.page - 0 || 0,
      navData: [
        { name: require('../../static/img/logo.png'), path: '/logo' },
        { name: '集团简介', path: '/jtgk' },
        { name: '产业链及子公司', path: '/cyl' },
        { name: '产品及下载', path: '/cpxz' },
        { name: '企业文化', path: '/qywh' },
        { name: '合作伙伴', path: '/hzhb' },
        { name: '联系我们', path: '/lxwm' },
        { name: '信息披露', path: '/xxpl' }
      ]
    }
  }
//   methods: {
//     changeLang () {
//       let locale = this.$i18n.locale
//       locale === 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh'
//     }
//   }
}
</script>

<style lang="scss" scoped>
.sy {
    width: 100%;
    height: 100%;
    .nav_wrap {
        width: 100%;
        background: #3b2d50;
        max-width: 19.2rem;
        margin: 0 auto;
    }
    nav {
        height: .88rem;
        background: #3b2d50;
        margin: 0 auto;
        line-height: .88rem;
        color: #fff;
        font-size: .18rem;
        ul {
            box-sizing: border-box;
            display: flex;
            max-width: 12rem;
            justify-content: space-between;
            li {
                text-align: center;
                cursor: pointer;
                padding: 0 .1rem;

            }
            .logo {
                width: 1.67rem;
                height: .65rem;
                padding-top: 7px;
            }
            .nav_li {
                background-color: #de101d;
            }
            .zyw {
                color: #d91a21;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue